<template>
  <div class="editor-elements">
    <div class="editor-elements__handle">
      <fai class="editor-elements__icon" icon="plus"></fai>
    </div>
    <div class="editor-elements__content">
      <div class="editor-elements__group" v-for="(group, i) in groups" :key="i">
        <h4 class="editor-elements__group-title">{{ $t(group.name) }}</h4>
        <div class="editor-elements__items">
          <div
            class="editor-elements__item"
            @click="item.handler"
            v-for="(item, o) in group.items"
            :key="o"
          >
            <div class="editor-elements__item-wrapper">
              <fai class="editor-elements__icon" :icon="item.icon" size="lg"></fai>
              <p class="editor-elements__title">{{ $t(item.title) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: null,
      groups: [{
        name: 'view.flow.editor.elementGroups.messages',
        items: [{
          title: 'view.flow.editor.element.message',
          icon: 'comment-alt',
          handler: this.add('message')
        }, {
          title: 'view.flow.editor.element.qr',
          icon: 'stream',
          handler: this.add('qr')
        }, {
          title: 'view.flow.editor.element.carousel',
          icon: 'images',
          handler: this.add('carousel')
        }, {
          title: 'view.flow.editor.element.attachment',
          icon: 'photo-video',
          handler: this.add('attachment')
        }, {
          title: 'view.flow.editor.element.media',
          icon: 'image',
          handler: this.add('media')
        }]
      }, {
        name: 'view.flow.editor.elementGroups.userManagement',
        items: [{
          title: 'view.flow.editor.element.group',
          icon: 'user-friends',
          handler: this.add('group')
        }, {
          title: 'view.flow.editor.element.data',
          icon: 'user-tag',
          handler: this.add('data')
        }, {
          title: 'view.flow.editor.element.input',
          icon: 'keyboard',
          handler: this.add('userInput')
        }, {
          title: 'view.flow.editor.element.contact',
          icon: 'comments',
          handler: this.add('contact')
        }, {
          title: 'view.flow.editor.element.regulations',
          icon: 'file-contract',
          handler: this.add('regulations')
        }, {
          title: 'view.flow.editor.element.removeUser',
          icon: 'user-times',
          handler: this.add('userDel')
        }]
      }, {
        name: 'view.flow.editor.elementGroups.devBlocks',
        items: [{
          title: 'view.flow.editor.element.function',
          icon: 'code',
          handler: this.add('function')
        }, {
          title: 'view.flow.editor.element.code',
          icon: ['fab', 'js-square'],
          handler: this.add('code')
        }, {
          title: 'view.flow.editor.element.comment',
          icon: 'sticky-note',
          handler: this.add('comment')
        },
        {
          title: 'view.flow.editor.element.dataLoad',
          icon: 'user-tag',
          handler: this.add('dataLoad')
        }]
      }, {
        name: 'view.flow.editor.elementGroups.flowControl',
        items: [{
          title: 'view.flow.editor.element.redirect',
          icon: 'directions',
          handler: this.add('redirect')
        }, {
          title: 'view.flow.editor.element.if',
          icon: 'code-branch',
          handler: this.add('if')
        }, {
          title: 'view.flow.editor.element.delayedMessage',
          icon: 'hourglass-start',
          handler: this.add('delayedMessage')
        }, {
          title: 'view.flow.editor.element.delayedMessageCancel',
          icon: 'hourglass-end',
          handler: this.add('delayedMessageCancel')
        }, {
          title: 'view.flow.editor.element.switch',
          icon: 'list',
          handler: this.add('switch')
        }, {
          title: 'view.flow.editor.element.random',
          icon: 'random',
          handler: this.add('random')
        }, {
          title: 'view.flow.editor.element.gotoLabel',
          icon: 'tag',
          handler: this.add('gotoLabel')
        }, {
          title: 'view.flow.editor.element.goto',
          icon: 'location-arrow',
          handler: this.add('goto')
        }, {
          title: 'view.flow.editor.element.blockInsert',
          icon: 'level-down-alt',
          handler: this.add('blockInsert')
        }]
      }, {
        name: 'view.flow.editor.elementGroups.integrations',
        items: [{
          title: 'view.flow.editor.element.email',
          icon: 'envelope-open-text',
          handler: this.add('email')
        }, {
          title: 'view.flow.editor.element.otn',
          icon: 'broadcast-tower',
          handler: this.add('otn')
        }, {
          title: 'view.flow.editor.element.handover',
          icon: 'hands-helping',
          handler: this.add('handover')
        }]
      }],
      elements: {
        message: {
          action: 'message',
          message: {
            type: 'text',
            text: {},
            buttons: []
          }
        },
        redirect: {
          action: 'redirect',
          target: '',
          passVariables: false,
          variables: {}
        },
        qr: {
          action: 'qr',
          options: {
            saveToUserData: false,
            userDataName: '',
            storage: 'database'
          },
          replies: [{
            text: {},
            data: {
              passVariables: false,
              variables: {},
              target: null,
              value: '',
              payload: ''
            }
          }, {
            text: {},
            data: {
              passVariables: false,
              variables: {},
              target: null,
              value: '',
              payload: ''
            }
          }]
        },
        group: {
          action: 'group',
          operation: 'assign',
          groupUuid: null
        },
        data: {
          action: 'data',
          operation: 'set',
          storage: 'database',
          data: {
            name: '',
            value: null
          }
        },
        attachment: {
          action: 'attachment',
          attachmentUuid: null
        },
        carousel: {
          action: 'carousel',
          aspectRatio: 'horizontal',
          cards: [{
            title: {},
            subtitle: {},
            image_url: '',
            buttons: [],
            default_url: ''
          }]
        },
        code: {
          action: 'code',
          code: `(async function () {\n  try {\n    \n  } catch(e) {\n    throw e\n  }\n})()`,
          sign: ''
        },
        function: {
          action: 'function',
          function: ''
        },
        contact: {
          action: 'contact',
          value: false
        },
        regulations: {
          action: 'regulations',
          value: false
        },
        userDel: {
          action: 'delete'
        },
        userInput: {
          action: 'input',
          type: 'text',
          name: '',
          storage: 'database',
          additionalFilters: {
            min: 1,
            max: 10
          },
          incorrectInputMessage: {
            text: 'This data doesn\'t look correct. Try again, or click cancel',
            cancelButton: 'Cancel',
            cancelTarget: ''
          }
        },
        comment: {
          action: 'comment',
          text: 'New comment...'
        },
        email: {
          action: 'email',
          recipients: ['person@example.com'],
          title: 'Email title',
          content: '<h1>New email</h1><p>This is your email content</p>'
        },
        media: {
          action: 'media',
          mode: 'attachment',
          type: 'image',
          payload: '',
          buttons: []
        },
        if: {
          action: 'if',
          condition: '',
          steps: [],
          elseSteps: []
        },
        otn: {
          action: 'otn',
          name: '',
          content: {},
          confirmationBlock: ''
        },
        delayedMessage: {
          action: 'delay',
          time: 1,
          timeUnit: 'h',
          block: '',
          name: '',
          from: 1
        },
        delayedMessageCancel: {
          action: 'delayCancel',
          name: ''
        },
        dataLoad: {
          action: 'dataLoad',
          storage: 'database',
          name: ''
        },
        switch: {
          action: 'switch',
          expression: '',
          cases: [],
          defaultSteps: []
        },
        random: {
          action: 'random',
          blocks: []
        },
        gotoLabel: {
          action: 'gotoLabel',
          label: ''
        },
        goto: {
          action: 'goto',
          label: ''
        },
        blockInsert: {
          action: 'blockInsert',
          block: ''
        },
        handover: {
          action: 'handover',
          type: 'take',
          appId: '',
          metadata: '',
        }
      }
    }
  },
  methods: {
    add(element) {
      return () => {
        this.$emit('add', JSON.parse(JSON.stringify(this.elements[element])))
      }
    },

    populateRepliesLocales() {
      for (let locale in this.$store.state.flowLocales) {
        this.elements.qr.replies[0].text[locale] = 'New reply'
        this.elements.qr.replies[1].text[locale] = 'New reply'
        this.elements.message.message.text[locale] = 'New text message'
        this.elements.otn.content[locale] = 'OTN title'
        this.elements.carousel.cards[0].title[locale] = this.$t('view.flow.block.carousel.cardTitle')
        this.elements.carousel.cards[0].subtitle[locale] = this.$t('view.flow.block.carousel.cardSubtitle')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-elements {
  z-index: 1500;
  position: fixed;
  width: 320px;
  right: 0;
  top: 15%;
  transform: translateX(320px);
  background-color: white;
  box-shadow: -2px 0px 7px -5px rgba(0, 0, 0, 0.35);
  border-radius: 12px 0 0 12px;
  padding: 10px 0;
  transition: transform 0.2s ease;
  will-change: transform;

  &:hover {
    transform: translateX(0);
  }

  &__handle {
    background-color: $primary;
    position: absolute;
    width: 50px;
    height: 50px;
    top: calc(50% - 25px);
    left: calc(calc(50% - 128px) * -1);
    border-radius: 80px 0 0 80px;
    box-shadow: -2px 0px 6px -3px rgba(0, 0, 0, 0.35);

    svg {
      width: 15px;
      margin-left: 10px;
      margin-top: 15px;
      color: white;
    }
  }

  &__content {
    position: relative;
    background-color: white;
    padding: 10px 10px 10px 15px;
    max-height: 78vh;
    overflow-y: auto;
  }

  &__group {
    margin-bottom: 5px;
  }

  &__group-title {
    margin-top: 2px;
    margin-bottom: 5px;
  }

  &__items {
    @include alignedFlex(flex-start);
    flex-wrap: wrap;
  }

  &__item {
    @include alignedFlex();
    width: 24%;
    flex-wrap: wrap;
    cursor: pointer;
    transition: background-color 0.2s ease;
    padding: 1px 0;
  }

  &__item-wrapper {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    border-radius: 4px;
    padding: 9px 5px;

    &:hover {
      background-color: $bgLightGrey;
    }
  }

  &__icon {
    display: block;
    width: 100%;
    font-size: 1.2em;
  }

  &__title {
    font-size: 0.7em;
    font-family: "Work Sans";
    margin: 0;
    margin-top: 4px;
  }
}
</style>
